import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { Container, Col, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// api
import { getBlogPosts } from 'api/blog';
import { getAllRelatedPost } from 'api/blog';
// components
import CardPost from 'components/blog/cardPost';
import './blog.scss';

const Post = () => {
  let { year, month, day, slug } = useParams();
  const [post, setPost] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const { t } = useTranslation(['blog']);

  useEffect(() => {
    const getPostData = async () => {
      const payload = { year, month, day, slug };
      const { status, data } = await getBlogPosts(payload);
      if (status === 200) {
        setPost(data);
        setLoaded(true);
      }
    };
    getPostData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  if (loaded) {
    const categoryTitle = post?.category?.name;

    return (
      <div className="content mainDiv mx-auto">
        <div className="container-fluid blog mx-auto">
          {/* <Head description={descripcion_pub} title={title} noIndex={true} /> */}
          <Row>
            <Col md={12}>
              <h1 className="page-title static-title">{t('libelistworld')} - {categoryTitle}</h1>
            </Col>
          </Row>
          <div className="blogContainer">
            <CardPost event={post} isContainer={true} isOnlyPost={true} />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <Container fluid={true} className="container-spinner">
        <Spinner animation={'grow'} className="spinner-blog" />
      </Container>
    );
  }
};

export default Post;